import React, { useState } from 'react';
import queryString from 'query-string';
import { useLocation } from 'react-router-dom';
import BaseFilter, {
  FilterTypeEnum,
} from '../../../components/base/BaseFilter';

function LevelFilter({
  backAction = () => { },
}) {
  const location = useLocation();

  const parsedSearch = queryString.parse(location.search);
  const searchIsActive = parsedSearch['is_active'] || '';

  const [isActive, setIsActive] = useState(searchIsActive);;

  const content = [
    {
      title: 'Is active',
      data: [
        { name: 'Active', pk: 'true' },
        { name: 'Deactive', pk: 'false' },
      ],
      value: isActive,
      setValue: setIsActive,
      component: FilterTypeEnum.singleChoice,
      className: 'fit-content-height-area',
    },
  ];

  return <BaseFilter content={content} backAction={backAction} />;
}

export default LevelFilter;
